import justeamsImg from "../assets/projects/justeams.png";
import asistenciaImg from "../assets/projects/asistencia.png";
import negocionImg from "../assets/projects/negocion.png";

const projects = [
  {
    id: "negocion",
    name: "Negocion",
    image: negocionImg,
    description: "Gestión integral para comercios: ventas, stock, caja, clientes y cuenta corriente en un solo dashboard, con reportes en tiempo real.",
    tech: ["Next.js", "TypeScript", "Prisma", "PostgreSQL"],
    link: "https://negocion-lac.vercel.app",
    linkLabel: "Ver demo",
  },
  {
    id: "asistencia",
    name: "Asistencia",
    image: asistenciaImg,
    description: "Sistema de control de asistencia para una empresa real: fichada por DNI desde tablet, panel de administración y reportes. En producción hoy.",
    tech: ["React", "Django", "PostgreSQL"],
    link: null,
    linkLabel: "Proyecto privado",
  },
  {
    id: "justeams",
    name: "JusTeams",
    image: justeamsImg,
    description: "Arma equipos balanceados para partidos o torneos en segundos: cargás jugadores y niveles, el sistema arma los equipos parejos.",
    tech: ["React", "Node.js", "Prisma"],
    link: "https://github.com/Joakkoo/JusTeams",
    linkLabel: "Ver en GitHub",
  },
];

export default projects;
